module.exports = __webpack_public_path__ + "media/images/signatures/edgar_derek-6b19707034b8c8fcdd19bc2a0bcbc3b26f74512aa93654edf385d05a656e9419.png";